import { purify } from "../../_src/components/purify";

export function searchAndloadMoreInfoSenar() {
    var btnLoadMore = document.querySelector("[data-action=load-more-infosenar]")

    function loadMore(loadMore) {
        var form = document.querySelector('#filter-infoSenar');
        var data = new FormData(form);

        btnLoadMore ? btnLoadMore.classList.add("loading") : ''

        document.querySelectorAll("#filter-infoSenar fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        if (!loadMore) {
            document.querySelector("#result-infosenar").innerHTML = "";
            document.querySelector(".loader-infosenar").classList.remove("hidden")
        }

        var pagina = loadMore ? btnLoadMore.getAttribute("data-page") : 1;

        fetch(`/acervo-digital/infosenar/ajax/infosenar/p${pagina}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-infosenar").insertAdjacentHTML('beforebegin', response);

                if ( parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.totalpages)) {
                    btnLoadMore.remove()
                }

            } else {
                document.querySelector("#result-infosenar").innerHTML = purify(response);

                searchAndloadMoreInfoSenar();
            }

        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            if (!loadMore) {
                document.querySelector(".loader-infosenar").classList.add("hidden")
            }

            btnLoadMore ? btnLoadMore.classList.remove("loading") : ''

            document.querySelectorAll("#filter-infoSenar fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })

        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { loadMore(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }

    document.querySelector("#filter-infoSenar").addEventListener("change", function(event) { event.preventDefault(), setTimeout(() => { loadMore(false) }, 100),btnLoadMore ? btnLoadMore.dataset.page = "1" : "1" }, false);
}


if (document.querySelector("#filter-infoSenar")) {
    searchAndloadMoreInfoSenar();
}
